import { breakpoints } from './_breakpoints';

export const sizesResponsive = {
  m: `(max-width: ${breakpoints.m.max})`,
  xxs: `(max-width: ${breakpoints.xxs.max})`,
};
